import { FormLayout } from "src/components/form/formLayout/FormLayout"
import { Skeleton } from "../../../skeleton/Skeleton"

export const VisibilityFormSkeleton = () => (
	<FormLayout $width="half">
		<Skeleton.RadioGroup count={2} withLabel withDescriptions />
		<Skeleton.RadioGroup count={2} withLabel />
	</FormLayout>
)
